import config from '@config';
import ProjectService from './ProjectService';

export default new ProjectService(
  config.runServerHost,
  config.backendHost,
  config.backendBasePath,
);
